export default "__VITE_ASSET__CINqfsSP__"